import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Vehicle } from 'src/app/shared/models/Vehicle';

@Component({
  selector: 'app-vehicle-popup',
  templateUrl: './vehicle-popup.component.html',
  styleUrls: ['./vehicle-popup.component.css']
})
export class VehiclePopupComponent implements OnInit {
  @Input() vehicleList: Vehicle[];
  @Input() byVehicle: boolean;
  @Input() currentVehicle: Vehicle;
  @Output() closeModalEvent = new EventEmitter<void>();
  @Output() vehicleSelected = new EventEmitter<string>();

  formControl: FormControl;
  currentPage: number = 0;
  vehiclesPerPage: number = 12;
  vehiclesFiltered: Vehicle[] = [];
  vehiclesToShow: Vehicle[] = []; // Array para mostrar en la vista
  textoVehicle: string = '';

  constructor() { }

  ngOnInit() {
    // Ordenamos una sola vez al inicializar
    this.vehicleList = this.vehicleList.sort((a, b) => a.name.localeCompare(b.name));
    this.vehiclesFiltered = [...this.vehicleList];
    this.updateVehiclesToShow();
  }

  filtrarPatentes(): void {
    if (this.textoVehicle === '') {
      this.vehiclesFiltered = [...this.vehicleList];
    } else {
      // Siempre filtrar desde la lista original
      this.vehiclesFiltered = this.vehicleList.filter(vehicle =>
        vehicle.name && vehicle.name.toLowerCase().includes(this.textoVehicle.toLowerCase())
      );
    }

    this.currentPage = 0;
    this.updateVehiclesToShow();
  }

  private updateVehiclesToShow(): void {
    const startIndex = this.currentPage * this.vehiclesPerPage;
    this.vehiclesToShow = this.vehiclesFiltered.slice(startIndex, startIndex + this.vehiclesPerPage);
  }

  closeModal() {
    this.closeModalEvent.emit();
  }

  saveVehicle() {
    if (this.formControl) {
      this.formControl.setValue(this.currentVehicle);
    }
    this.closeModal();
  }

  selectVehicle(event: any, vehicle: Vehicle) {
    this.currentVehicle = vehicle;
    this.vehicleSelected.emit(vehicle._id);
  }

  previousVehiclesPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updateVehiclesToShow();
    }
  }

  nextVehiclesPage() {
    const totalPages = Math.ceil(this.vehiclesFiltered.length / this.vehiclesPerPage);
    if (this.currentPage < totalPages - 1) {
      this.currentPage++;
      this.updateVehiclesToShow();
    }
  }

  get disable_prev(): boolean {
    return this.currentPage === 0;
  }

  get disable_next(): boolean {
    const totalPages = Math.ceil(this.vehiclesFiltered.length / this.vehiclesPerPage);
    return this.currentPage >= totalPages - 1;
  }

  get totalPages(): number {
    return Math.ceil(this.vehiclesFiltered.length / this.vehiclesPerPage);
  }

  get currentPageDisplay(): string {
    return `Página ${this.currentPage + 1} de ${this.totalPages}`;
  }
}